<template>
	<div class="small-12 sidebarWidget flex vertical-align animated fadeIn" style="padding-top:10px;">
        <div class="small-12 title">
            <h3 class="flex vertical-align">Recent Activity</h3>
        </div>
        <div class="small-12 timelineWidget borderRadius8 border light">
            <div class="small-12" v-if="resident_events.length > 0">
                <ul class="float-left small-12 flex">
                    <li class="small-12" v-for="(event, index) in resident_events" :key="index">
                        <div class="timelineBadge"></div>
                        <div class="timelinePanel auto flex">
                            <p class="small-12 timeAgo">
                                {{ event.meta.created_at | fromNow }}
                            </p>
                            <span class="badge borderRadius4 flex" v-if="event.type == 'invoice.payment.succeeded'">Payment Succeeded</span>
                            <span class="badge borderRadius4 flex" v-else-if="event.type == 'invoice.payment.submitted'">Payment Submitted</span>
                            <span class="badge borderRadius4 flex" v-else-if="event.type == 'invoice.payment.failed'">Payment Failed</span>
                            <span class="badge borderRadius4 flex" v-else-if="event.type == 'invoice.create'">Invoice Created</span>
                            <span class="badge borderRadius4 flex" v-else-if="event.type == 'invoice.update'">Invoice Updated</span>
                            <h6 class="small-12">
                                {{ event.attributes.title }}
                            </h6>
                        </div>
                    </li>
                </ul>
                <div class="small-12 action flex justify-center border-top" v-if="lease">
                    <router-link :to="{ name: 'LeaseRent', params: { id: lease.relationships.property, leaseID: lease.id } }" class="blueButton flex vertical-align borderRadius4">
                        <i class="material-icons-outlined flex vertical-align justify-center">find_in_page</i>
                        View Lease
                    </router-link>
                </div>
            </div>
            <div class="small-12 widgetChart emptyWidget small" style="padding-top:15px;" v-else>
                <div class="small-12 wrap flex justify-center">
                    <picture class="small-12 flex justify-center" style="width:80%; height:auto;">
                        <img width="180" :src="empty_image" alt="Rooftops">
                    </picture>
                </div>
                <div class="small-12 emptyDetails">
                    <h6 class="small-12 text-center"> 
                        No Activity Found
                    </h6>
                    <p class="small-12 text-center"> 
                        There are no events available at this time.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    // Import the events
	import { GetEvents } from '@/events/residents/GetEvents'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'LatestTimeline',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			GetEvents

		],

		/*
		**  Set the props
		*/

		props: {

			lease: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/framework%2Fmega-menu-investors-bg.svg?alt=media&token=204b9fa8-6d90-422f-9c82-4b5aff6d2141'

		}),

		/*
		**  Watch em'
		*/

		watch: {

			lease: {

				immediate: true, // Load on created
				handler(lease) {

					/*
					**  Get the latest events
					**  @method: Events/Residents/GetEvents
					*/

                    if (lease) this.getEventsHandler(this.$route.params.id, lease.relationships.resident, 5);

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			fromNow: function(value) {

                return moment(value * 1000).fromNow();

            }

		}

	}

</script>